import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appNavigateToUrl]'
})
export class NavigateToUrlDirective {
  @Input('appNavigateToUrl') url: string;

  constructor(private readonly router: Router) {}

  @HostListener('click', ['$event'])
  onNavigate(event: Event): void {
    event.stopPropagation();
    const decodedUrl = decodeURIComponent(this.url);
    const absoluteUrl = decodedUrl.startsWith('/') ? decodedUrl : '/' + decodedUrl;

    if (absoluteUrl !== this.router.url) {
      this.router.navigateByUrl(absoluteUrl);
    }
  }
}
